enum Env {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
  SERVICE_WORKER = 'serviceWorker',
}

export {
  Env,
};
